import React from 'react'
import dayjs from 'dayjs'
import get from 'lodash/get'
import keyBy from 'lodash/keyBy'
import merge from 'lodash/merge'
import * as validators from 'constructicon/lib/validators'

import RichText from '../../../ui/RichText'

export default ({
  customFields = [],
  customSupporterPage,
  fundraisingPage,
  tagDefinitions,
  styles,
  userPage
}) => {
  const { fitness = {} } = customSupporterPage
  const { promptTags, promptCustomFields } = get(customSupporterPage, 'onboarding', {})

  const splitOnDelimiter = (string) => {
    const hasDelimiter = delimiter => string.split(delimiter).length > 1

    if (hasDelimiter('\n')) {
      return string.split('\n')
    }

    return string.split(',')
  }

  return {
    fields: merge(
      {},
      fitness.showGoal && {
        fitnessGoal: {
          label: fitness.label || `Fitness goal (in ${fitness.goalUom})`,
          type: 'number',
          required: true,
          initial: fundraisingPage.fitnessGoal,
          validators: [validators.required('Please enter a fitness goal')]
        }
      },
      promptTags && keyBy(
        tagDefinitions.map(tag => ({
          name: tag.id,
          label: <RichText styles={styles.label}>{tag.label}</RichText>,
          type: 'select',
          placeholder: 'Please select',
          options: tag.values.map(option => ({
            label: option.trim(),
            value: option.trim()
          })),
          required: tag.required,
          initial: fundraisingPage.segmentation[tag.id] || tag.initial,
          validators: tag.required
            ? [validators.required('Please select an option')]
            : []
        })),
        'name'
      ),
      promptCustomFields && keyBy(customFields.map(field => {
        const fieldProps = {
          name: field.name,
          label: <RichText styles={styles.label}>{field.label}</RichText>,
          type: field.type,
          required: field.required === 'Yes',
          order: field.order,
          initial: userPage.metadata[field.name] || field.initial,
          validators: field.required === 'Yes' ? [
            validators.required(field.validationLabel || 'This field is required')
          ] : []
        }

        switch (field.type) {
          case 'select':
            return {
              ...fieldProps,
              options: [
                { label: 'Please select', value: '' },
                ...splitOnDelimiter(field.options || '')
                  .map(option => ({ label: option.trim(), value: option.trim() }))
              ]
            }
          case 'date':
            return {
              ...fieldProps,
              showSelects: true
            }
          case 'birthday':
            return {
              ...fieldProps,
              type: 'date',
              showSelects: true,
              validators: [
                ...fieldProps.validators,
                val => !!val && dayjs(val).isAfter(dayjs().subtract(18, 'year').startOf('day')) && 'You must be at least 18 years old'
              ].filter(Boolean)
            }
          default:
            return fieldProps
        }
      }), 'name')
    )
  }
}
